import colors from '@galo-monitor/styles/colors'

export default () => ({
  searchField: {
    marginLeft: 10,
    marginRight: 10
  },
  popoverItem: {
    textAlign: 'end',
    color: colors.darkGrey2,
    width: 185,
    '&:hover': {
      color: colors.primary,
      opacity: 0.9
    }
  }
})
